var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Basic',[_c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.deviceMode !== 'pc')?_c('router-view',{staticClass:"page-wrapper"}):_c('div',{staticClass:"page-pc-wrapper"},[_c('router-view',{staticClass:"page-wrapper"}),_c('LayoutFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }